import React, { PropsWithChildren } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

export interface LanguageTooltipProps {
  tooltipText?: string
}

export const LanguageTooltip: React.FC<PropsWithChildren<LanguageTooltipProps>> = ({ tooltipText, children }) => {
  if (!tooltipText) {
    return <>{children}</>
  }

  return (
    <OverlayTrigger placement='top' overlay={<Tooltip>{tooltipText}</Tooltip>}>
      <span>{children}</span>
    </OverlayTrigger>
  )
}
